// menu-mobile.js 			~/js/
////////////////////////////////////////////////////////////

const menuButton = document.querySelector('button.hamburger');
const menuMobile = document.querySelector('.menu-mobile');
const subMenuTrigger = document.querySelectorAll('li.has-sub-menu');
const mobileSubmenu = document.querySelectorAll('.mobile-submenu');

// Main menu
// Activate Hamburger, Show the menu, Stop body scroll, reset submenu
if (menuButton && menuMobile) {
  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('is-active');
    menuMobile.classList.toggle('is-active');
    document.body.classList.toggle('menu-active');
    menuMobile.scrollTop = 0;
    // Remove active if it's already active to start over
    mobileSubmenu.forEach((menu) => {
      if (menu.classList.contains('is-active')) {
        menu.classList.remove('is-active');
        // Wait to hide the element until it animates away
        hideMenu(menu);
      }
    });
  });
}

// Sub menu
// Add listener to each menu item with a submenu,
// Show the submenu for the item clicked
// Apply a back eventlistener for the submenu
// Close the submenu when back is clicked
if (subMenuTrigger && mobileSubmenu) {
  subMenuTrigger.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      let subMenuID = trigger.textContent;
      if (subMenuID.indexOf(' ') >= 0) {
        subMenuID = subMenuID.replaceAll(' ', '-');
      }
      const thisSubmenu = document.querySelector(
        '.mobile-submenu.sub-' + subMenuID,
      );
      const thisSubBack = thisSubmenu.querySelector('.back');
      thisSubmenu.style.display = 'block';
      // Wait to show element until it is un-hidden
      setTimeout(() => {
        thisSubmenu.classList.add('is-active');
        menuMobile.scrollTop = 0;
        thisSubBack.addEventListener('click', () => {
          thisSubmenu.classList.remove('is-active');
          // Wait to hide element until it animates away
          hideMenu(thisSubmenu);
        });
      }, 10);
    });
  });
}

// Hide the menus
let hideMenu = (e) => {
  setTimeout(() => {
    e.style.display = 'none';
  }, 200);
};
